import omnitureHelper from 'utils/omnitureHelper';
const pageType = 'WriteReview';
const pageName = 'WriteReviewPage';
function getProductString() {
    return (omnitureHelper.getValueFromPageContext('WriteReview', 'sproduct') ||
        omnitureHelper.getValueFromPageContext('WriteReview', 'products'));
}
function trackWriteReviewAction(trackType, source) {
    omnitureHelper.trackLink(Object.assign({
        prop3: pageType,
        prop4: pageName,
        products: getProductString()
    }, source && { prop62: source }), trackType);
}
export function trackAddImageClick() {
    trackWriteReviewAction('UGC_ImagesinReview_AddImageClick');
}
export function trackSelectSource() {
    trackWriteReviewAction('UGC_ImagesinReview_AddImage_Selectsource', 'AddImageReview_source_gallery');
}
export function trackAddImageServerError() {
    trackWriteReviewAction('UGC_ImagesinReview_AddImage_SERVER_ERROR');
}
export function trackAddImageFileSizeError() {
    trackWriteReviewAction('UGC_ImagesinReview_AddImage_FILE_SIZE_ERROR');
}
export function trackAddImageFilePathError() {
    trackWriteReviewAction('UGC_ImagesinReview_AddImage_FILE_PATH_ERROR');
}
export function trackSubmitWithoutImages() {
    trackWriteReviewAction('UGC_ImagesinReview_AddImage_SubmitWithoutImages');
}
export function trackSubmitWithoutImagesCancel() {
    trackWriteReviewAction('UGC_ImagesinReview_AddImage_SubmitWithoutImagesCancel');
}
export function trackDeleteImage() {
    trackWriteReviewAction('UGC_ImagesinReview_DeleteImage');
}
